module.exports = __webpack_public_path__ + "static/HF_BJSSC-04154815fea602d071d468dd3f2e18dd.png";